/**
* Radio validation
*/

const submitBtn = document.querySelector('.js-order-submit-btn');
const radioInputs: any = document.querySelectorAll('.is-radio');
const radioNames = ['kind', 'color', 'usage', 'notice'];
const errorMsg = "選択してください。";

const orderRadio = () => {
  submitBtn?.addEventListener('click', (e: any) => {
    for (let ctr = 0; ctr < radioInputs.length; ctr++) {
      radioInputs.forEach((radioInput: any) => {
        let radios = radioInput.querySelectorAll(`input[name=${radioNames[ctr]}]`);
        let error = radioInput.querySelector(".form__error");

        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked == true) {
            error.classList.remove("show")
            break;
          }
          else {
            error.classList.add("show")
            error.innerHTML = errorMsg
          }
        }
      })
    }
  });

  for (let ctr = 0; ctr < radioInputs.length; ctr++) {
    radioInputs.forEach((radioInput: any) => {
      let radios = radioInput.querySelectorAll(`input[name=${radioNames[ctr]}]`);
      let error = radioInput.querySelector(".form__error");

      radios.forEach((radio:any) => {
        radio.addEventListener("click", () => {
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked == true) {
              error.classList.remove("show")
              break;
            }
            error.classList.add("show")
            error.innerHTML = errorMsg
          }
        })
      })
    })
  }
}

export default orderRadio
